import { render, staticRenderFns } from "./BiddingResultDialog.pug?vue&type=template&id=4956b3e2&scoped=true&lang=pug&"
import script from "./BiddingResultDialog.vue?vue&type=script&lang=js&"
export * from "./BiddingResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./BiddingResultDialog.scss?vue&type=style&index=0&id=4956b3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956b3e2",
  null
  
)

export default component.exports